<div class="intro right-side">
    <!-- Loader -->
    <loading *ngIf="(kakao$ | async).loading === false"></loading>

    <div class="device-wrapper">
        <div class="contenido">
            <form #kakaoForm id="form-biz" action="https://bizmessage.kakao.com/chat/open" method="post" [target]="target$ | async">
                <input type="hidden" name="uuid" [value]="(kakao$ | async).configuration.key" />
                <button *ngIf="(isPage$ | async) === false" type="submit" value="TALK" class="btn btn-kakao btn--full">
                    {{ 'dev.chatbot.kakao.button' | translate }}
                </button>
            </form>
        </div>
    </div>
</div>
